import { NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { BraintreePaypalCheckoutComponentDef } from '@df/module-braintree/paypal/braintree-paypal-checkout.component.def';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { StatusAppBusyStateComponent } from '../../../ui/display/busy-state/status-app-busy-state.component';
@Component({
    selector: 'braintree-paypal-checkout',
    templateUrl: './braintree-paypal-checkout.html',
    standalone: true,
    imports: [NgClass, StatusAppBusyStateComponent, TranslationModule]
})
export class BraintreePaypalCheckoutComponent extends BraintreePaypalCheckoutComponentDef {}
